import React from 'react';

function App() {
  const value = 'Manan';
  return <div>Hello {value}</div>;
}

export default App;
